import { render, staticRenderFns } from "./ConfirmEula.vue?vue&type=template&id=1a10e270&scoped=true&"
import script from "./ConfirmEula.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEula.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmEula.vue?vue&type=style&index=0&id=1a10e270&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10e270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VDialog,VSpacer})
